<button
  class="btn btn-default btn-white btn-sm btn-reaction"
  data-cy="add-emoji-reaction"
  cdkOverlayOrigin #trigger="cdkOverlayOrigin"
  (mouseenter)="buttonHovered.next(true)"
  (mouseleave)="buttonHovered.next(false)"
  (click)="react($safeNavigationMigration(value?.id))">
    @if(reactions.length > 0) {
        <div class="emoticon-reactions d-flex justify-content-start">
            @for (reaction of reactions; track reaction.id; let last = $last) {
                @if (reaction.count > 0) {
                    <span class="emoticon-reaction d-block" [ngClass]="{'me-2': !last}"
                          [class.btn-reaction-active]="value?.id === reaction?.id">
                        @if (reaction.smiley) {
                        <span>{{reaction.smiley}} <small>{{reaction.count}}</small></span>
                        } @else {
                        <span><i class="{{reaction.icon}}"></i> <small>{{reaction.count}}</small></span>  
                        }
                    </span>
                }
            }
        </div>
    }
    @if(!value) {
        <span class="react-label" [ngClass]="{'ms-3': reactions.length > 0}">
            <i class="fa-regular fa-sharp fa-regular fa-face-smile-plus"></i> {{
                'comment-card.react' | translate }}
        </span>
        
    }       
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayOpen]="isOpened$ | async">
  <div
    class="d-flex bg-white border emoji-reactions"
    (mouseenter)="overlayHovered.next(true)"
    (mouseleave)="overlayHovered.next(false)">
    @for (reaction of options; track $index) {
      @if (reaction.smiley) {
      <button
        (click)="react(reaction.id)"
        class="btn btn-default btn-white btn-sm fs-3"
        [ngClass]="{'border-start ms-1 ps-2 pe-1': reaction.id === 'agree', 'selected': reaction.id === value?.id}"
        [matTooltip]="reaction.label | translate"
        matTooltipPosition="above">
        <span>{{reaction.smiley}}</span>
      </button>
      }
    }
  </div>
</ng-template>